(function(app, ng) {

    app.controller("editEnrollmentController", editEnrollmentController);

    editEnrollmentController.$inject = ["_", "$state", "$mdDialog", "enrollmentApi", "clientApi"];
    function editEnrollmentController(_, $state, $mdDialog, enrollmentApi, clientApi) {
        var $ctrl = this;
        // window.test = this;

        $ctrl.$onInit = () => {
            $ctrl.enrollment.Client = $ctrl.clientDetails; // So that the enrollment has complete client info
        }

        ng.extend($ctrl,
            {
                ui: {},
                close: close,
                goToClient: goToClient,
                update: update,
                removeEnrollment: removeEnrollment
            });

        function close() { $mdDialog.cancel() };

        function goToClient() {
            $state.go("Home.Client", { clientId: $ctrl.enrollment.ClientId }, { reload: true });
            $mdDialog.cancel();
        }

        function update() {
            $ctrl.ui.saving = true;

            if ($ctrl.enrollment.Client.Type.Id !== $ctrl.enrollment.Client.TypeId) {
                $ctrl.enrollment.Client.Type = _.find($ctrl.clientTypes,
                    function(type) {
                        return type.Id === $ctrl.enrollment.Client.TypeId;
                    });
            }

            clientApi.update($ctrl.enrollment.Client).then(function() {
                enrollmentApi.updateClientEnrollment($ctrl.enrollment.Id, $ctrl.enrollment).then(function () {
                    $ctrl.ui.saving = true;
                    $mdDialog.hide($ctrl.enrollment);
                });
            });

        }

        function removeEnrollment($event) {
            var confirm = $mdDialog.confirm({
                theme: "confirmDelete",
                title: "Are you sure you want to remove this client from the pipeline?",
                targetEvent: $event,
                ariaLabel: "Confirm",
                ok: "Remove",
                cancel: "Cancel",
                clickOutsideToClose: false,
                multiple: true,
                onComplete: function() {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });

            $mdDialog.show(confirm).then(function() {
                enrollmentApi.delete($ctrl.enrollment.Id).then(function() {
                    _.remove($ctrl.pipeline.Enrollments,
                        function (enrollment) {
                            return enrollment.Id === $ctrl.enrollment.Id;
                        });
                });

                $mdDialog.hide(null);
            });
        }        
    }
})(window.app, window.angular); //jshint ignore:line